export enum ResolvableServiceFormTab {
  ResolvableServiceInfo = 'resolvableServiceInfo',
  ResolvableServiceQuotationInfo = 'resolvableServiceQuotationInfo',
  MaterialsSelection = 'materialsSelection',
  MaterialsOrder = 'materialsOrder',
  MaterialsUsage = 'materialsUsage',
  CostsSelection = 'costsSelection',
  CostsOrder = 'costsOrder',
  CostsUsage = 'costsUsage',
}
